package nl.appstuff.padelchecker.pages.padel

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.Page
import nl.appstuff.padelchecker.site.PageSeo
import nl.appstuff.padelchecker.site.components.NavBar
import nl.appstuff.padelchecker.site.components.sections.FooterSection
import nl.appstuff.padelchecker.site.directory.Directory
import nl.appstuff.padelchecker.site.directory.DirectoryContentBox
import nl.appstuff.padelchecker.site.directory.DirectoryGrid
import nl.appstuff.padelchecker.site.directory.DirectoryHeading
import nl.appstuff.padelchecker.site.directory.DirectoryLink
import nl.appstuff.padelchecker.site.directory.DirectoryParagraph
import nl.appstuff.padelchecker.site.directory.DirectorySubheading
import nl.appstuff.padelchecker.site.localization.LocalSiteStrings
import org.jetbrains.compose.web.css.vh

@Page("/padel")
@Composable
fun PadelIndexPage() {
    val strings = LocalSiteStrings.current
    PageSeo(
        title = strings.directoryIndexSeoTitle(Directory.clubs.size),
        description = strings.directoryIndexSeoDescription(Directory.clubs.size),
        canonicalPath = "/padel",
    )

    Column(modifier = Modifier.fillMaxWidth().minHeight(100.vh)) {
        NavBar()
        DirectoryContentBox {
            DirectoryHeading(strings.directoryIndexTitle)
            DirectoryParagraph(strings.directoryIndexIntro(Directory.clubs.size))

            DirectorySubheading(strings.directoryProvincesHeading)
            DirectoryGrid {
                Directory.provinces.sortedBy { it.name }.forEach { province ->
                    DirectoryLink(
                        href = "/padel-in/${province.slug}",
                        label = strings.directoryProvinceLink(province.name, province.clubCount),
                    )
                }
            }

            DirectorySubheading(strings.directoryCitiesHeading)
            DirectoryGrid {
                Directory.cities.sortedBy { it.name }.forEach { city ->
                    DirectoryLink(
                        href = "/padel/${city.slug}",
                        label = strings.directoryCityLink(city.name, city.clubCount),
                    )
                }
            }
        }
        FooterSection()
    }
}
